import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
  },
  iconBadge: {
    ...theme.mixins.appIconTintSquare,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
  },
  topIcon: {
    width: 28,
    height: 28,
    display: 'block',
  },
  description: {
    width: '100%',
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  versionCompareRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  versionBadgeSecondary: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    backgroundColor: alpha(theme.palette.text.secondary, UiAlpha.Tint),
    color: theme.palette.text.secondary,
  },
  versionBadgePrimary: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
  },
  versionArrow: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(22),
    flexShrink: 0,
  },
  versionValue: {
    wordBreak: 'break-word',
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(2),
    marginTop: theme.spacing(0.5),
  },
  updateButton: {
    width: '100%',
  },
  buttonIcon: {
    width: 20,
    height: 20,
    display: 'block',
  },
  closeButton: {
    width: '100%',
  },
}));
